import { Component, createRef } from 'react';

class DropFileComponent extends Component {

  ref = createRef();

  constructor(props) {
    super(props);

    this.state = {
      isDragging: false
    }
  }

  

  componentDidMount() {
    let div = this.ref.current;
    div.addEventListener('dragstart', this.handleDragStart);
    div.addEventListener('dragenter', this.handleDragEnter);
    div.addEventListener('dragleave', this.handleDragLeave);
    div.addEventListener('dragover', this.handleDrag);
    div.addEventListener('drop', this.handleDrop);

    this.dragCount = 0;
  }

  componentWillUnmount() {
    let div = this.ref.current;
    div.removeEventListener('dragstart', this.handleDragStart);
    div.removeEventListener('dragenter', this.handleDragEnter);
    div.removeEventListener('dragleave', this.handleDragLeave);
    div.removeEventListener('dragover', this.handleDrag);
    div.removeEventListener('drop', this.handleDrop);
  }

  handleDragStart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    e.dataTransfer.clearData();
  }

  handleDragEnter = (e) => {
    console.log('Drag enter file');
    e.preventDefault();
    e.stopPropagation();

    this.dragCount++;
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      
      this.setState(  {isDragging: true} );
    }
  }

  handleDragLeave = (e) => {
    console.log('Drag leave file');
    e.preventDefault();
    e.stopPropagation();
    this.dragCount--;
    if (this.dragCount > 0)
      return;
    this.setState( {isDragging: false} );
  }

  handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
  }

  handleDrop = (e) => {
    console.log('Dropped file')
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      this.props.handleDrop(e.dataTransfer.files);
      this.dragCount = 0;
    }

    
  }


  render() {
    return (
      <div ref={this.ref}
            style={{
              display: this.props.show ? 'inline-block' : 'none', 
              visibility: this.props.show ? 'visible' : 'hidden',
              position: 'relative'
            }}
      >
        {this.state.isDragging && 
          <div 
            style={{
              position: 'absolute',
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              width: '50vw',
              height: '25vh',
              zIndex: 9999,
              marginLeft: '25vw',
              background: 'rgba(0.5,0.5,0.5, 0.3)',
              borderRadius: '13px',
              color: 'white'
            }}
          >

          </div>
        }
        <div 
          style={{
            border: 'dotted gray 2px',
            borderRadius: '13px',
            width: '50vw',
            height: '25vh',
            textAlign: 'center',
            display: "flex",
            justifyContent: 'center',
            alignItems: 'center',
            
             marginLeft: '25vw',
            
          }}
        >
         {this.props.children}
        </div>
      </div>
      
      );
  }
}

export default DropFileComponent;
